"use strict";
/**
 * BEST2 Data Stack
 *
 * Manages data values pushed/popped by stack-related opcodes.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataStack = exports.DEFAULT_STACK_DEPTH = void 0;
const ediabasx_core_1 = require("@emdzej/ediabasx-core");
exports.DEFAULT_STACK_DEPTH = 256;
class DataStack {
    stack;
    maxDepth;
    constructor(options = {}) {
        this.maxDepth = options.maxDepth ?? exports.DEFAULT_STACK_DEPTH;
        this.stack = [];
    }
    pushByte(value) {
        if (this.stack.length >= this.maxDepth) {
            throw new ediabasx_core_1.EdiabasError(ediabasx_core_1.EdiabasErrorCodes.STACK_OVERFLOW, `Data stack overflow: exceeded maximum depth of ${this.maxDepth}`);
        }
        this.stack.push(value & 0xff);
    }
    popByte() {
        const value = this.stack.pop();
        if (value === undefined) {
            throw new ediabasx_core_1.EdiabasError(ediabasx_core_1.EdiabasErrorCodes.STACK_UNDERFLOW, "Data stack underflow: POP without matching PUSH");
        }
        return value;
    }
    peekByte(offset = 0) {
        const index = this.stack.length - 1 - offset;
        if (index < 0 || index >= this.stack.length) {
            return undefined;
        }
        return this.stack[index];
    }
    push(value) {
        this.pushByte(value);
    }
    pop() {
        return this.popByte();
    }
    peek(offset = 0) {
        return this.peekByte(offset);
    }
    swap() {
        if (this.stack.length < 2) {
            return;
        }
        const top = this.stack.length - 1;
        const tmp = this.stack[top];
        this.stack[top] = this.stack[top - 1];
        this.stack[top - 1] = tmp;
    }
    clear() {
        this.stack.length = 0;
    }
    depth() {
        return this.stack.length;
    }
    setDepth(depth) {
        const nextDepth = Math.max(0, Math.min(this.maxDepth, depth | 0));
        if (nextDepth < this.stack.length) {
            this.stack.length = nextDepth;
            return;
        }
        while (this.stack.length < nextDepth) {
            this.stack.push(0);
        }
    }
    getMaxDepth() {
        return this.maxDepth;
    }
    snapshot() {
        return [...this.stack];
    }
}
exports.DataStack = DataStack;
//# sourceMappingURL=stack.js.map